import { gql } from '@apollo/client';

export const IS_USER_LOGGED_IN = gql`
  query isUserLoggedIn {
    isLoggedIn @client
    type @client
  }
`;
